import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';
import { REMOTE_SEARCH_ROW_KEY } from 'projects/service/src/app/shared/utils/remote-search-grid-api';

// Cycle Counts popup → Technicians (pick the requester) on @inavista/components. Same columns, labels, order,
// alignment, toolbar (Search, Clear filters) and Proceed arrow as the Syncfusion grid it replaces. Rows come from the
// same endpoint with the same request (POST ServiceEmployee/GetEmployeeSearchView, RemoteSearchGridApi); 50 rows per
// request, loaded as the user scrolls. No paging (Martin).

export const CYCLE_COUNT_RESOURCE_SELECTION_PERSISTENCE_KEY = 'rims.service.cycle-count-resource-selection-technicians';
export const CYCLE_COUNT_RESOURCE_SELECTION_URL = 'rims-search://cycle-count-resource-selection';

// EmployeeSearchView fields. Employee Id was hidden and out of the column chooser.
export const CYCLE_COUNT_RESOURCE_SELECTION_COLUMNS: [string, string][] = [
  ['employeeId', 'nvarchar'],
  ['employeeName', 'nvarchar'],
  ['email', 'nvarchar'],
  ['telephone', 'nvarchar'],
  ['serviceDepartment', 'nvarchar'],
  ['warehouse', 'nvarchar'],
];

export function buildCycleCountResourceSelectionGridConfig(): GridConfig {
  const order = CYCLE_COUNT_RESOURCE_SELECTION_COLUMNS.map(([c]) => c);
  const shown = order.filter(c => c !== 'employeeId');
  return {
    apiBaseUrl: CYCLE_COUNT_RESOURCE_SELECTION_URL,
    keyColumn: REMOTE_SEARCH_ROW_KEY,
    // The old page size.
    pageSize: 50,
    rowHeight: 30,
    defaultColumnOrder: order,
    hiddenByDefaultColumns: ['employeeId', REMOTE_SEARCH_ROW_KEY],
    columnLabels: {
      employeeId: 'Employee Id', employeeName: 'Name', email: 'Email', telephone: 'Telephone',
      serviceDepartment: 'Service Department', warehouse: 'Warehouse',
    },
    // Every column left, as the old grid (no textAlign).
    columnAlign: Object.fromEntries(shown.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // No widths in the old grid: the columns shared the popup's width.
    columnWidths: Object.fromEntries(shown.map(c => [c, 150])),
    stretchColumns: true,
    // The old Actions column was 120px wide.
    actionsColumnMinWidth: 120,
    searchHint: 'Searches every column.',
    // The old toolbar: Search and Clear all Filters only (showColumnChooser was set, but no Columns button was in
    // the toolbar, so none showed).
    enableColumnsPicker: false,
    enableExport: false,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableRefresh: false,
    // Ctrl+click adds a sort column, as the old grid (Syncfusion multi-sort).
    multiSort: true,
    enableResetLayout: true,
    // The footer gives the old "Total Records" count.
    enableFooter: true,
    loadingIndicator: 'banner',
    emptyStateMessage: 'No records to display',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: CYCLE_COUNT_RESOURCE_SELECTION_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  };
}
